import { IGetBenchmarkColor } from '../interfaces';

const INDEX_COLORS = {
  cdi: '#0000E0',
  CDI: '#0000E0',
  ibov: '#D47500',
  IBOVESPA: '#D47500',
  ipca: '#DB0A5B',
  IPCA: '#DB0A5B',
  poup: '#600060',
  POUPANÇA: '#600060',
  selic: '#00AA00',
  SELIC: '#00AA00',
  dolar: '#527AC2',
  DÓLAR: '#527AC2',
  ibxx: '#939393',
  'IBRX BRASIL': '#939393',
  'ima-b': '#6B8E23',
  'IMA-B': '#6B8E23',
  ihfa: '#FF00FF',
  IHFA: '#FF00FF',
  'igp-m': '#8D6708',
  'IGP-M': '#8D6708',
  'irf-m': '#E26A6A',
  'IRF-M': '#E26A6A',
  idiv: '#1D781D',
  IDIV: '#1D781D',
  smll: '#545454',
  'SMALL CAP': '#545454',
  'sp500-tr': '#8778E8',
  'S&P 500': '#8778E8',
  'sp500-brl': '#009739',
};

export class BenchmarkColorRepo implements IGetBenchmarkColor {
  public getColor(benchmark: string): string {
    const color = INDEX_COLORS[benchmark];

    return color || '#333';
  }
}
